import { KnownApplicantFulfillmentMethod } from '@modules/checkout-store';

export interface IOrderTicket {
  ticketTypeId: string;
  title: string;
  description: string;
  alias: string;
  subtitle: string;
  isDirectDebit: boolean;
  price: number;
  membershipNumber: string;
  customerType: string;
  travelMethod: string;
  travelTime: string;
  fullfillmentMethod?: KnownApplicantFulfillmentMethod;
  zone: string;
  fullName: string;
  validFrom: string;
  validTo: string;
  quantity: number;
  id: string;
}
